module.exports = __webpack_public_path__ + "static/media/DMSans-Bold.d2286fb4.woff2";